<div [formGroup]="form" [id]="fieldName">
  @if (fieldName) {
    <p-float-label>
      <p-inputgroup>
        @if (prefix) {
          <p-inputgroup-addon>
            <ng-template [ngTemplateOutlet]="prefix"></ng-template>
          </p-inputgroup-addon>
        }
        <p-password
          #pwdInput
          [id]="fieldName + 'Input'"
          [required]="isRequired()"
          [formControlName]="fieldName"
          [styleClass]="styleClass + ' form-control'"
          [toggleMask]="showUnhide"
          [feedback]="showFeedback"
          [autocomplete]="autocomplete"
          appendTo="body"
        >
          <ng-template #header>
            <h6>Pick a password</h6>
          </ng-template>
          <ng-template pTemplate="footer">
            <p-divider />
            <p class="p-mt-2">Suggestions</p>
            <ul class="p-pl-2 p-ml-2 p-mt-0" style="line-height: 1.5">
              <li>At least one lowercase</li>
              <li>At least one uppercase</li>
              <li>At least one numeric</li>
              <li>Minimum 8 characters</li>
            </ul>
          </ng-template>
        </p-password>
        @if (suffix) {
          <ng-template [ngTemplateOutlet]="suffix" />
        }
      </p-inputgroup>
      @if (label) {
        <label [for]="fieldName + 'Input'" class="block" [class.invalid]="myControl?.invalid && myControl?.touched"
          >{{ label }}
          @if (attribute?.displayNameSuffixIcon) {
            <i inline style="font-size: small">{{ attribute.displayNameSuffixIcon }}</i>
          }
          @if (isRequired()) {
            <span style="color: red">*</span>
          }
        </label>
      }
    </p-float-label>
    @if (displayHint || attribute?.displayHint) {
      <small class="block">
        {{ displayHint ? displayHint : attribute?.displayHint }}
      </small>
    }
    <ng-content></ng-content>
    <s-form-error-input
      [groupName]="groupName"
      [fieldName]="fieldName"
      [form]="form"
      [apiError]="apiError"
      [schema]="schema"
    />
  }
</div>
